import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { ModalService } from '../../../services';
import { SearchModalComponent } from '../../modals';
import { Search } from '../../../models';

@Component({
  selector: 'app-formly-input-search',
  templateUrl: './formly-input-search.component.html',
  styleUrl: './formly-input-search.component.scss',
})
export class FormlyInputSearchComponent extends FormlyFieldBaseComponent implements OnInit {
  constructor(private modalService: ModalService) {
    super();
  }

  ngOnInit(): void {
    this.reset();
  }

  clearSearch(searchBox: HTMLInputElement) {
    this.form.patchValue({ [this.key]: '' } as any);
    searchBox.focus();
    if (this.props.clear) {
      this.props.clear();
    }
  }

  search() {
    const search = this.field.model[this.key];
    if (this.props.search) {
      this.props.search(search);
    } else if (this.props.service) {
      this.props.service
        .search(
          search,
          this.props.id ?? this.field.model.id,
          this.props.id2 ?? this.field.model.id2,
          this.field.model.includeAll,
          this.props.allowIncludeAllBlankSearch,
          this.props.allowBlankSearch,
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((results: any[]) => this.subscribeResults(results, search, true));
    } else if (this.props.serviceTextileMan) {
      this.props.serviceTextileMan
        .search(search)
        .pipe(takeUntil(this.destroy$))
        .subscribe((results: any[]) => this.subscribeResults(results, search, false));
    }
  }

  private subscribeResults(results: any[], search: string, showSave: boolean) {
    if (this.props.results) {
      this.props.results(of(results));
    }

    if (search && results.length === 1) {
      this.onSelected(results[0]);
    } else if (this.props.openModal) {
      const { modal, component } = this.modalService.openXL<SearchModalComponent>(SearchModalComponent);
      component.header = this.props.label;
      component.columnDefs = this.props.columnDefs;
      component.service = this.props.service;
      component.model = { search, includeAll: false } as Search;
      component.id = this.props.id;
      component.allLabel = this.props.allLabel;
      component.createComponent = this.props.createComponent;
      component.results$ = of(results);
      component.showSave = showSave;
      modal.result.then(
        (result) => this.onSelected(result),
        () => {},
      );
    }
  }

  private onSelected(result: any) {
    if (this.props.selected) {
      this.props.selected(result);
    }
  }

  private reset() {
    if (this.key && !this.model[this.key]) {
      this.form.patchValue({ [this.key]: '' } as any);
    }
  }

  edit(event: any) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }
}
